import { reactive } from "vue"

export interface MeterReadModalState {
  show: boolean
  readFrequency?: string
}

const meterReadModalState = reactive<MeterReadModalState>({
  show: false,
  readFrequency: undefined,
})

export function useMeterReadModalState() {
  const openModal = (readFrequency: string) => {
    meterReadModalState.show = true
    meterReadModalState.readFrequency = readFrequency
  }

  const closeModal = () => {
    meterReadModalState.show = false
    meterReadModalState.readFrequency = undefined
  }

  return {
    state: meterReadModalState,
    openModal,
    closeModal,
  }
}
